import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const servicesRoutes: Route = {
    path: 'services',
    data: { title: 'services' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'pest' },
        {
            path: 'pest',
            loadComponent: () => import('./pest/pest/pest.component').then((m) => m.PestComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Pest' },
        },
        {
            path: 'pest-detection',
            loadComponent: () =>
                import('./pest/pest-detection/pest-detection.component').then((m) => m.PestDetectionComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Pest Detection' },
        },
        {
            path: 'vra-map',
            loadComponent: () => import('./vra/vra-map/vra-map.component').then((m) => m.VraMapComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'VRA Map' },
        },
        {
            path: 'vra',
            loadComponent: () => import('./vra/vra/vra.component').then((m) => m.VraComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'VRA' },
        },
        {
            path: 'evapotranspiration-kc',
            loadComponent: () =>
                import('./climate/evapotranspiration-kc/evapotranspiration-kc.component').then(
                    (m) => m.EvapotranspirationKcComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'evapotranspiration-kc' },
        },
        {
            path: 'vra-sentinel-record',
            loadComponent: () =>
                import('./vra/vra-sentinel-record/vra-sentinel-record.component').then((m) => m.VraSentinelRecordComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'VRA Sentinel Record' },
        },
        {
            path: 'vra-zone-entry',
            loadComponent: () =>
                import('./vra/vra-zone-entry/vra-zone-entry.component').then((m) => m.VraZoneEntryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'VRA Zone Entry' },
        },
        {
            path: 'weather-spot',
            loadComponent: () =>
                import('./weather/weather-spot/weather-spot.component').then((m) => m.WeatherSpotComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Weather Spot' },
        },
        {
            path: 'agroclimate',
            loadComponent: () =>
                import('./climate/agroclimate/agroclimate.component').then((m) => m.AgroclimateComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'agroclimate' },
        },
        {
            path: 'weather-historical-hourly',
            loadComponent: () =>
                import('./weather/weather-historical-hourly/weather-historical-hourly.component').then(
                    (m) => m.WeatherHistoricalHourlyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'weather-historical-hourly' },
        },
        {
            path: 'weather-historical-daily',
            loadComponent: () =>
                import('./weather/weather-historical-daily/weather-historical-daily.component').then(
                    (m) => m.WeatherHistoricalDailyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'weather-historical-daily' },
        },
        {
            path: 'weather-forecast-hourly',
            loadComponent: () =>
                import('./weather/weather-forecast-hourly/weather-forecast-hourly.component').then(
                    (m) => m.WeatherForecastHourlyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'weather-forecast-hourly' },
        },
        {
            path: 'weather-forecast-daily',
            loadComponent: () =>
                import('./weather/weather-forecast-daily/weather-forecast-daily.component').then(
                    (m) => m.WeatherForecastDailyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'weather-forecast-daily' },
        },
        {
            path: 'problematic-spot',
            loadComponent: () =>
                import('./problematic/problematic-spot/problematic-spot.component').then((m) => m.ProblematicSpotComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Problematic spot' },
        },
        {
            path: 'problematic-spot-status',
            loadComponent: () =>
                import('./problematic/problematic-spot-status/problematic-spot-status.component').then(
                    (m) => m.ProblematicSpotStatusComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Problematic spot status' },
        },
        {
            path: 'vra-implementation-strategy',
            loadComponent: () =>
                import('./vra/vra-implementation-strategy/vra-implementation-strategy.component').then(
                    (m) => m.VraImplementationStrategyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Vra implementation strategy' },
        },
        {
            path: 'vra-unit',
            loadComponent: () => import('./vra/vra-unit/vra-unit.component').then((m) => m.VraUnitComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Vra unit' },
        },
        {
            path: 'irrigation-program',
            loadComponent: () =>
                import('./irrigation/irrigation-program/irrigation-program.component').then((m) => m.IrrigationProgramComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Irrigation program' },
        },
        {
            path: 'irrigation-recommendation',
            loadComponent: () =>
                import('./irrigation/irrigation-recommendation/irrigation-recommendation.component').then(
                    (m) => m.IrrigationRecommendationComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'irrigation-recommendation' },
        },
        {
            path: 'disease',
            loadComponent: () => import('./disease/disease/disease.component').then((m) => m.DiseaseComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Disease' },
        },
        {
            path: 'rotation-disease-risk',
            loadComponent: () =>
                import('./disease/rotation-disease-risk/rotation-disease-risk.component').then(
                    (m) => m.RotationDiseaseRiskComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Rotation Disease Risk' },
        },
    ],
};
